/** @format */
import {
	AccordionModule,
	AffirmPayLaterModule,
	CommonTimerModule,
	DSProductRecommendationsComponent,
	ExclusiveProductPanelModule,
	GoogleAdManagerComponent,
	PaypalPayLaterModule,
	ProTipsComponent,
	ProductRecommendationsComponent,
	ProgressSpinnerModule
} from '@shared/components';
import {
	AddToCartButtonComponent,
	AddToCartSectionComponent,
	AddToCartSuccessComponent,
	ChangeStoreButtonComponent,
	FulfillmentButtonSubtextComponent,
	InStorePickupButtonComponent,
	SameDayDeliveryButtonComponent,
	ShipToMeButtonComponent
} from '@pdp/add-to-cart/components';
import {
	AemArticlesComponent,
	AppSnackbarComponent,
	BNPLComponent,
	BackToSearchResultsComponent,
	BrandLinkComponent,
	BreadcrumbComponent,
	CarouselComponent,
	CarouselSkeletonLoaderComponent,
	CompareSectionComponent,
	FrequentlyBoughtTogetherComponent,
	GtgtContentComponent,
	HighlightsComponent,
	HomrRichContentComponent,
	HomrStatsSlidersComponent,
	HomrTextLinkComponent,
	HomrWireSpotComponent,
	NotifyMePanelComponent,
	PriceComponent,
	ProductDescriptionComponent,
	ProductImageCarouselComponent,
	ProductImageViewerComponent,
	ProductInStoreServicesComponent,
	ProductInfoSpecsComponent,
	PromotionComponent,
	ReadyForNextRoundAddOnsComponent,
	ReturnPolicyComponent,
	ShippingComponent,
	ShoppableImageComponent,
	Sketchfab3dImageryComponent,
	SnackbarComponent,
	StyliticsComponent,
	StyliticsJumplinkComponent,
	StyliticsShopTheSetComponent,
	SyndigoComponent,
	TechSpecsComponent,
	TextileLabelComponent,
	WarrantyButtonComponent
} from '@pdp/components';
import { AggregatedRatingComponent } from '@product-reviews/components/aggregated-rating';
import { ReviewBVReviewsComponent } from '@product-reviews/components/review-bv-reviews';
import { ReviewHighlightContainerComponent } from '@product-reviews/components/review-highlight-container';
import { ReviewHighlyRatedFeaturesComponent } from '@product-reviews/components/review-highly-rated-features';
import { ReviewHighlyRatedFeaturesModalComponent } from '@product-reviews/components/review-highly-rated-features-modal';
import { ReviewMultimediaCountComponent } from '@product-reviews/components/review-multimedia-count';
import { ReviewQuestionsAndAnswersV2Component } from '@product-reviews/components/review-questions-and-answers-v2';
import { ReviewRatingSummaryStarsComponent } from '@product-reviews/components/review-rating-summary-stars';
import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import { ProductRecommendationsRailComponent } from '@product-recommendations/components';
import {
	ExclusiveProductAdComponent,
	ExclusiveProductInfoComponent,
	ExclusiveProductOverlayComponent,
	ExclusiveProductPromoMessageComponent
} from '@pdp/exclusive-products/components';
import {
	GoldMemberStatusModule,
	ScoreRewardComponent,
	ScorecardPointsComponent
} from '@scorecard/components';
import {
	HmfAlertBannerComponent,
	HmfButtonComponent,
	HmfTextLinkComponent
} from '@dsg-tech/homefield-angular';
import { HotOnSocialButtonComponent, ImagesCarouselComponent } from '@social-content/components';

import { AttributesModule } from '@pdp/attributes/components';
import { CommonModule } from '@angular/common';
import { CustomizeProductButtonComponent } from '@pdp/custom/components';
import { DynamicProductTemplateModule } from '../shared/dynamic-product-template-module.interface';
import { HomrBannerComponent } from '@shared/homr/components';
import { InStockDefaultComponent } from './in-stock-default.component';

@NgModule({
	declarations: [InStockDefaultComponent],
	imports: [
		AccordionModule,
		AddToCartButtonComponent,
		AddToCartSectionComponent,
		AddToCartSuccessComponent,
		AemArticlesComponent,
		AppSnackbarComponent,
		AffirmPayLaterModule,
		AggregatedRatingComponent,
		AttributesModule,
		BackToSearchResultsComponent,
		BNPLComponent,
		BrandLinkComponent,
		BreadcrumbComponent,
		ChangeStoreButtonComponent,
		CommonModule,
		CommonTimerModule,
		CustomizeProductButtonComponent,
		ExclusiveProductAdComponent,
		ExclusiveProductInfoComponent,
		ExclusiveProductOverlayComponent,
		ExclusiveProductPanelModule,
		ExclusiveProductPromoMessageComponent,
		FrequentlyBoughtTogetherComponent,
		FulfillmentButtonSubtextComponent,
		GoldMemberStatusModule,
		GoogleAdManagerComponent,
		GtgtContentComponent,
		HighlightsComponent,
		HmfAlertBannerComponent,
		HmfButtonComponent,
		HmfTextLinkComponent,
		HomrBannerComponent,
		HomrTextLinkComponent,
		HomrStatsSlidersComponent,
		HomrWireSpotComponent,
		HomrRichContentComponent,
		HotOnSocialButtonComponent,
		ImagesCarouselComponent,
		InStorePickupButtonComponent,
		NotifyMePanelComponent,
		PaypalPayLaterModule,
		PriceComponent,
		ProductDescriptionComponent,
		ProductImageCarouselComponent,
		CarouselComponent,
		CarouselSkeletonLoaderComponent,
		ProductImageViewerComponent,
		ProductInfoSpecsComponent,
		ProductRecommendationsComponent,
		ProductRecommendationsRailComponent,
		ProductInStoreServicesComponent,
		ProgressSpinnerModule,
		PromotionComponent,
		ProTipsComponent,
		ReadyForNextRoundAddOnsComponent,
		ReturnPolicyComponent,
		ReviewBVReviewsComponent,
		ReviewHighlightContainerComponent,
		ReviewHighlyRatedFeaturesComponent,
		ReviewHighlyRatedFeaturesModalComponent,
		ReviewMultimediaCountComponent,
		ReviewQuestionsAndAnswersV2Component,
		ReviewRatingSummaryStarsComponent,
		SameDayDeliveryButtonComponent,
		ScorecardPointsComponent,
		ScoreRewardComponent,
		ShippingComponent,
		ShipToMeButtonComponent,
		ShoppableImageComponent,
		SnackbarComponent,
		Sketchfab3dImageryComponent,
		StyliticsComponent,
		StyliticsJumplinkComponent,
		StyliticsShopTheSetComponent,
		SyndigoComponent,
		TechSpecsComponent,
		TextileLabelComponent,
		WarrantyButtonComponent,
		CompareSectionComponent,
		DSProductRecommendationsComponent
	],
	providers: []
})
export class InStockDefaultModule implements DynamicProductTemplateModule<InStockDefaultComponent> {
	constructor(private readonly resolver: ComponentFactoryResolver) {}

	public resolveComponentFactory(): ComponentFactory<InStockDefaultComponent> {
		return this.resolver.resolveComponentFactory(InStockDefaultComponent);
	}
}
